import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { IconUi } from '@shared/components'

interface Data {
  url: string | ArrayBuffer
  alt?: string
}

@Component({
  selector: 'image-preview-modal',
  imports: [IconUi],
  template: `
    <section class="relative flex max-h-[90vh] w-full max-w-2xl flex-col items-center">
      <button
        data-test="close-button"
        class="absolute -top-10 right-0"
        aria-label="Cerrar"
        (click)="dialogRef.close()">
        <icon-ui
          name="close"
          class="text-accent-900 h-6 w-6" />
      </button>
      <img
        data-test="preview-image"
        [src]="data.url"
        [alt]="data.alt ?? ''"
        class="max-h-[90vh] w-full rounded-2xl object-contain" />
    </section>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImagePreviewModal {
  dialogRef = inject(DialogRef)
  data: Data = inject(DIALOG_DATA)
}
